<template>
    <div class="col-md-12">
        <div class="form-group">
            <label>{{title}}</label>
            <div class="bootstrap-duallistbox-container row moveonselect moveondoubleclick">
                <div class="box1 col-md-6">
                    <label for="bootstrap-duallistbox-nonselected-list_" style="display: none;"></label>
                    <span class="info-container">
                        <small class="info">Selecione para adicionar</small> </span>
                    <input class="form-control filter" type="text" placeholder="Filtrar">
                    <div class="btn-group buttons">
                        <button @click="addAll()" type="button" class="btn btn-sm moveall btn-outline-success"
                            title="Move all">&gt;&gt;</button>
                    </div>
                    <select multiple="multiple" id="bootstrap-duallistbox-nonselected-list_" name="_helper1"
                        style="height: 102px;">
                        <option @click="addItem(item, i)" v-for="(item, i) in availableData" :key="`available${i}`"
                            :value="item.id">
                            {{item.assinatura_nome}} - {{item.assinatura_email}}</option>
                    </select>
                </div>
                <div class="box2 col-md-6">
                    <label for="bootstrap-duallistbox-selected-list_" style="display: none;"></label>
                    <span class="info-container">
                        <small class="info">{{selectedData.length}}
                            adicionados</small> </span>
                    <input class="form-control filter" type="text" placeholder="Filtrar">
                    <div class="btn-group buttons">
                        <button @click="removeAll()" type="button" class="btn btn-sm removeall btn-outline-danger"
                            title="Remove all">&lt;&lt;</button>
                    </div>
                    <select multiple="multiple" id="bootstrap-duallistbox-selected-list_" name="_helper2"
                        style="height: 102px;">
                        <option @click="removeItem(item, i)" v-for="(item, i) in selectedData" :key="`selected${i}`"
                            :value="item">
                            {{item.assinatura_nome}} - {{item.assinatura_email}}</option>
                        <option class="text-center" disabled v-if="!selectedData.length">Nenhum adicionado</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: String,
            storeAction: String,
            selectedData: []
        },
        data() {
            return {
                toAdd: [],
                toRemove: [],
                availableData: []
            }
        },
        methods: {
            fetchData() {
                this.availableData = [];
                this.$store.dispatch(this.storeAction).then(response => {
                    response.map(item => {
                        if (this.selectedData.findIndex(x => x.assinatura_email === item.assinatura_email) == -1) {
                            this.availableData.push(item);
                        }
                    });
                });
            },
            addItem(payload, i) {
                if (this.selectedData.findIndex(x => x.assinatura_email === payload.assinatura_email) == -1) {
                    this.selectedData.push(payload);
                }
                this.availableData.splice(i, 1);
            },
            removeItem(payload, i) {
                if (this.availableData.findIndex(x => x.assinatura_email === payload.assinatura_email) == -1) {
                    this.availableData.push(payload);
                }
                this.selectedData.splice(i, 1);
            },
            addAll() {
                this.availableData.map(payload => {
                    if (this.selectedData.findIndex(x => x.assinatura_email === payload.assinatura_email) == -1) {
                        this.selectedData.push(payload);
                    }
                })
                this.availableData = [];
            },
            removeAll() {
                this.selectedData.map(payload => {
                    if (this.availableData.findIndex(x => x.assinatura_email === payload.assinatura_email) == -1) {
                        this.availableData.push(payload);
                    }
                });
                this.selectedData.length = 0;
            }
        }

    }
</script>
<style>
    .bootstrap-duallistbox-container select {
        width: 100%;
        height: 300px;
        padding: 0;
    }

    .bootstrap-duallistbox-container .buttons {
        width: 100%;
        margin-bottom: -1px;
    }
</style>